import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Row,
    Col,
    Button
} from "reactstrap"
import { ToastContainer } from "react-toastify";

import LogsList from "./logsList";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

// Utilities
import {
    loadLogsData,
    clearLogsData,
    transformLogsToTableData,
    createNotificationHelpers,
    LOGS_TABLE_COLUMNS,
    MESSAGES
} from "../utils";

class Errors extends Component {
    constructor(props) {
        super(props)
        this.state = {
            TotalLogs: 0,
            LogsDetails: {
                columns: [],
                rows: []
            },
            loading: false
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    /**
     * Loads logs from API and updates state
     */
    loadLogs = async () => {
        this.setState({ loading: true });

        const logs = await loadLogsData(this.notify_error);

        if (logs) {
            const data = transformLogsToTableData(logs, LOGS_TABLE_COLUMNS);

            this.setState({
                TotalLogs: logs.length,
                LogsDetails: data,
                loading: false
            });

            this.notify_success(MESSAGES.LOGS_LOADED_SUCCESS);
        } else {
            this.setState({
                LogsDetails: {
                    columns: [],
                    rows: []
                },
                loading: false
            });
        }
    }

    componentDidMount() {
        this.loadLogs();
    }

    /**
     * Clears all logs and reloads the list
     */
    clearLogs = async () => {
        this.setState({ loading: true });

        try {
            const success = await clearLogsData(this.notify_success, this.notify_error);
            if (success) {
                await this.loadLogs();
            } else {
                this.setState({ loading: false });
            }
        } catch (error) {
            this.setState({ loading: false });
            throw error;
        }
    }

    /**
     * Renders the logs header with count and clear button
     */
    renderLogsHeader = () => {
        const { TotalLogs, loading } = this.state;

        const hasLogs = TotalLogs > 0;
        const logLabel = hasLogs && TotalLogs === 1 ? "Veeper error log" : "Veeper error logs";
        const helperMessage = hasLogs
            ? "Review the latest captured issues below."
            : "All clear! No errors have been reported.";

        const badgeStyle = {
            backgroundColor: "#dc3545",
            color: "#fff",
            borderRadius: "9999px",
            minWidth: "36px",
            height: "36px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: "16px",
            padding: "0 10px",
            marginRight: "12px"
        };

        return (
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center" style={{ paddingLeft: "34px" }}>
                    <span style={badgeStyle}>{TotalLogs}</span>
                    <div>
                        <p style={{ marginBottom: 0, fontWeight: 600 }}>{hasLogs ? logLabel : "No Veeper error logs"}</p>
                        <small style={{ color: "#6c757d" }}>{helperMessage}</small>
                    </div>
                </div>
                <div style={{ textAlign: "right", paddingBottom: "10px", paddingRight: "34px" }}>
                    <Button
                        size="md"
                        onClick={this.clearLogs}
                        className="btn btn-danger waves-effect waves-light"
                        disabled={!hasLogs || loading}
                    >
                        {loading ? "Clearing..." : "Clear Logs"}
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const { LogsDetails, loading } = this.state;
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Error Logs</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={t("Error Logs")}
                            breadcrumbItem={t("Error Logs")}
                        />
                        <ToastContainer />
                        <Row>
                            <Col xl={12}>
                                {this.renderLogsHeader()}
                                <LogsList loading={loading} logs={LogsDetails} />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

Errors.propTypes = {
    t: PropTypes.any
}

export default withTranslation()(Errors)
